import { Pipe } from '@angular/core';
var IntersectionPipe = (function () {
    function IntersectionPipe() {
    }
    IntersectionPipe.prototype.transform = function (input) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (!Array.isArray(input)) {
            return input;
        }
        // tslint:disable-next-line no-bitwise
        return args.reduce(function (n, c) { return n.filter(function (e) { return !!~c.indexOf(e); }); }, input);
    };
    IntersectionPipe.decorators = [
        { type: Pipe, args: [{ name: 'intersection' },] },
    ];
    /** @nocollapse */
    IntersectionPipe.ctorParameters = function () { return []; };
    return IntersectionPipe;
}());
export { IntersectionPipe };
//# sourceMappingURL=intersection.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/array/intersection.js
// module id = 227
// module chunks = 4